import React from 'react';
import { FadeIn } from './FadeIn';
import { Quote } from 'lucide-react';
export function TestimonialsSection() {
  const testimonials = [{
    quote: 'Me ayudó a cambiar por completo la forma en que entro a una entrevista. Dejé de sentirme evaluado y empecé a sentirme preparado para conversar.',
    name: 'Laura M.',
    role: 'Coordinadora de Operaciones',
    initials: 'LM'
  }, {
    quote: 'Aplicar estas preguntas me permitió entender mejor el rol y conectar mis respuestas con lo que realmente buscaban.',
    name: 'Diego R.',
    role: 'Gerente Comercial',
    initials: 'DR'
  }, {
    quote: 'Nunca había pensado que no hacer preguntas podía jugar tan en mi contra. Esta guía me abrió los ojos.',
    name: 'Andrea P.',
    role: 'Jefa de Proyecto',
    initials: 'AP'
  }];
  return <section className="py-20 lg:py-24 bg-lightGray px-4 sm:px-6 lg:px-8" data-id="element-156">
      <div className="max-w-7xl mx-auto" data-id="element-157">
        <FadeIn data-id="element-158">
          <h2 className="text-3xl md:text-4xl font-extrabold text-navy mb-16 text-center tracking-tight" data-id="element-159">
            Lo que dicen otros profesionales
          </h2>
        </FadeIn>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-160">
          {testimonials.map((testimonial, index) => <FadeIn key={index} delay={index * 0.2} data-id="element-161">
              <div className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 h-full flex flex-col relative" data-id="element-162">
                <Quote className="w-10 h-10 text-emerald/20 absolute top-6 right-6" data-id="element-163" />
                <p className="text-gray-700 text-lg mb-8 flex-grow relative z-10 italic" data-id="element-164">
                  "{testimonial.quote}"
                </p>
                <div className="flex items-center gap-4" data-id="element-165">
                  <div className="w-12 h-12 bg-emerald rounded-full flex items-center justify-center text-white font-bold text-lg flex-shrink-0" data-id="element-166">
                    {testimonial.initials}
                  </div>
                  <div data-id="element-167">
                    <p className="font-bold text-navy" data-id="element-168">{testimonial.name}</p>
                    <p className="text-sm text-gray-500" data-id="element-169">{testimonial.role}</p>
                  </div>
                </div>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}